const isShopifyShop = (user) => !!user?.shopify_shop;
export default isShopifyShop;
